import { render, staticRenderFns } from "./recommendCourse.vue?vue&type=template&id=c08ec670&scoped=true"
import script from "./recommendCourse.vue?vue&type=script&lang=js"
export * from "./recommendCourse.vue?vue&type=script&lang=js"
import style0 from "../index.css?vue&type=style&index=0&id=c08ec670&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08ec670",
  null
  
)

export default component.exports